import {
  serializable,
  alias,
  primitive,
} from "serializr";

export class ReportMacro {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("shortname", primitive()))
  shortname?: string;

  @serializable(alias("expanded_text", primitive()))
  expandedText?: string;

  @serializable(alias("admin_id", primitive()))
  adminId?: number;

  @serializable(alias("doctor_id", primitive()))
  doctorId?: number;

  @serializable(alias("created_at", primitive()))
  createdAt?: string;

  @serializable(alias("updated_at", primitive()))
  updatedAt?: string;
}

/** True if macro is org-level (created by admin), false if doctor-specific */
export function isOrgMacro(macro: ReportMacro): boolean {
  return !macro.doctorId;
}
